
// ROUTES
require('modules/dashboard/routes/dashboard');

// CONTROLLERS
require('modules/dashboard/controllers/dashboard');


angular.module('unica_dashboard', [

	// ROUTES
	'unica_dashboard.dashboard_routes',

	// CONTROLLERS
	'unica_dashboard.dashboard_controllers',

]);